import { render } from "./InputTypesTable.vue?vue&type=template&id=268a6bd8"
import script from "./InputTypesTable.vue?vue&type=script&lang=js"
export * from "./InputTypesTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__